import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AddressStaff } from "./AddressStaff";
import type { PersonAddressDTOBase } from "./PersonAddressDTOBase";
import type { PersonStaff } from "./PersonStaff";

export class PersonAddressStaff implements PersonAddressDTOBase {
  constructor(public readonly personId: PersonStaff | null, public readonly assignId: number, public readonly name: string | null, public readonly addressId: AddressStaff) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.personService().getPersonAddressStaffPersonId(this.assignId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
}
